import Vue from "vue";
import VueRouter from "vue-router";
import partnerStartup from "../views/partnerStartup";
import investStartup from "../views/investStartup";
import getHiredByStartup from "../views/getHiredByStartup";
Vue.use(VueRouter);

const Home = () => import("../views/home");
const login = () => import("../views/login");
const register = () => import("../views/register");
const logout = () => import("../views/logout");

const startupBySectorDatabase = () =>
  import("../views/startupBySectorDatabase");
const startUpDatabase = () => import("../views/startupDatabase");
const startupProfile = () => import("../views/startupProfile");

const routes = [
  { path: "/", name: "Home", component: Home },
  {
    path: "/startup-database/:sector",
    name: "startupBySectorDatabase",
    component: startupBySectorDatabase
  },
  {
    path: "/startup-database",
    name: "startUpDatabase",
    component: startUpDatabase
  },
  {
    path: "/view-profile/:team_id/program/:program_id",
    name: "startupProfile",
    component: startupProfile
  },
  {
    path: "/partner-startup/:startup_name/:startup_id",
    name: "partnerStartup",
    component: partnerStartup,
    meta:{
      requiresAuth:true
    }
  },
  {
    path: "/invest-startup/:startup_name/:startup_id",
    name: "investStartup",
    component: investStartup,
    meta:{
      requiresAuth:true
    }
  },
  {
    path: "/login",
    name: "login",
    component: login,
    meta:{
      requiresVisitor:true
    }
  },
  {
    path: "/register",
    name: "register",
    component: register,
    meta:{
      requiresVisitor:true
    }
  },
  {
    path: "/get-hired/:startup_name/:startup_id",
    name: "getHiredByStartup",
    component: getHiredByStartup,
    meta:{
      requiresAuth:true
    }
  },
  {
    path: '/logout',
    component: logout,
    name: 'logout',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/404",
    component: () => import("../views/errorPage.vue")
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

export default router;
